// English translations for BIMCORP MX.
// Edit strings here. Structure must mirror es.js.

const en = {
  nav: {
    howItWorks: "How It Works",
    services: "Services",
    fit: "Fit",
    insights: "Insights",
    faq: "FAQ",
    startCta: "Start Incorporation"
  },
  hero: {
    title: "BIMCORP MX",
    subtitle: "Incorporate in Mexico, properly.",
    description: "A tailored, end-to-end digital service designed for seamless market entry and total compliance.",
    description2: "Tell us what you want to set up in Mexico. We set up your legal structure and manage the entire process online.",
    animatedTitle: "Set a corporation",
    animatedSubtitle: "in México",
    lawyerLed: "Lawyer-led",
    notaryBacked: "Notary-backed",
    fullyOnline: "Fully online",
    tailoredFounders: "Tailored"
  },
  sections: {
    whatWeHandle: "What we handle",
    whatWeHandleDesc: "From legal incorporation to operational setup and ongoing compliance.",
    builtFor: "Built for",
    howItWorks: "A clear process from idea to incorporation",
    chooseRoute: "Choose the right route",
    installmentsAvailable: "(Installments available)",
    buildingComplex: "Building something more complex in Mexico?",
    buildingComplexDesc: "If your project involves foreign participation, land, restricted-zone property, or a more tailored ownership structure, we can guide that too.",
    commonQuestions: "Common questions",
    viewAllQuestions: "View all questions →",
    startWithStructure: "Start with the right structure",
    startWithStructureDesc: "Start your incorporation request and we'll recommend the best path before your call.",
    notSureRoute: "Not sure which route fits your business?",
    notSureRouteDesc: "Compare the available paths and choose the level of support your company needs in Mexico.",
    findYourFit: "Find your fit"
  },
  services: {
    companyIncorporation: "Company incorporation",
    companyIncorporationDesc: "Full management of the incorporation process, from notary liaison to final government registration.",
    rfcSetup: "Tax ID & E-signature",
    rfcSetupDesc: "Official Tax ID (RFC) registration and procurement of your corporate e-signature (e.firma) for full operational capacity.",
    bankAccount: "Bank Account Opening",
    bankAccountDesc: "End-to-end execution of your corporate banking setup and account activation.",
    governance: "Corporate Governance & Compliance",
    governanceDesc: "Management of corporate books, share issuance, and annual meetings, including copyright protection and foreign investor registration (RNIE)."
  },
  specialServices: {
    restrictedZone: "Restricted-zone projects",
    restrictedZoneDesc: "Ownership structures for real estate projects in coastal or border zones.",
    landRealEstate: "Land and real estate",
    landRealEstateDesc: "Legal structuring for acquisition, development, or property projects.",
    tailoredOwnership: "Complex ownership structures",
    tailoredOwnershipDesc: "Custom schemes for projects with foreign investment, multiple shareholders, or special control requirements."
  },
  audience: {
    founders: "Founders",
    foundersDesc: "Starting a business in Mexico",
    foreignInvestors: "Foreign investors",
    foreignInvestorsDesc: "Entering the Mexican market",
    operators: "Operators",
    operatorsDesc: "Needing a local vehicle",
    projectBuilders: "Project builders",
    projectBuildersDesc: "Requiring tailored structures"
  },
  pricing: {
    oneTimeFee: "one-time fee",
    upfrontSetup: "initial setup fee",
    monthlyPlan: "12-month minimum commitment",
    mostPopular: "Most Popular",
    month: "month",
    perMonthSuffix: "/month",
    vat: "+VAT"
  },
  pages: {
    servicesHero: "Services",
    servicesSubtitle: "Incorporation, operational setup, and ongoing compliance for companies entering Mexico.",
    howItWorksHero: "How it works",
    howItWorksSubtitle: "A tailored, fully online path to incorporate in Mexico with the right structure from day one.",
    faqHero: "Frequently Asked Questions",
    faqSubtitle: "Everything you need to know about incorporating in Mexico with BIMCORP MX.",
    wizardHero: "Start Incorporation",
    wizardSubtitle: "Tell us what you want to build in Mexico. We'll recommend the right route before your call."
  },
  servicesPage: {
    whatHappensNext: "What happens next",
    step1: "Start your incorporation request",
    step1Desc: "Share the key details of your Mexico setup, and select a package if you already know which one fits",
    step2: "Book a 20-minute validation call",
    step2Desc: "We review your request and confirm the right route, scope, and service fit before payment",
    step3: "Payment and onboarding",
    step3Desc: "Once aligned, we send the payment link and begin your onboarding",
    step4: "We handle the process",
    step4Desc: "We take care of incorporation and, if selected, RFC, bank account support, and governance setup",
    step5: "Delivery",
    step5Desc: "You receive your company documents and related deliverables",
    readyToStart: "Ready to start?",
    readyToStartDesc: "Start your incorporation request to get your tailored recommendation.",
    specialProjectTitle: "Special Project Structuring",
    specialProjectSubtitle: "Strategic Transactions",
    specialProjectDesc: "Tailored structuring for foreign ownership, investment, and complex projects in Mexico.",
    specialProjectBullet1: "Restricted-zone projects",
    specialProjectBullet2: "Structure ownership for land and property projects.",
    specialProjectBullet3: "Custom ownership and control structures for complex projects.",
    specialProjectPriceLabel: "Quoted",
    specialProjectPriceSub: "after review"
  },
  fitPage: {
    heroTitle: "Find the right fit for your business",
    heroSubtitle: "Not every company entering Mexico needs the same level of support. Choose the route that matches your current stage, operational needs, and compliance obligations.",
    compareRoutes: "Compare the routes",
    compareRoutesSub: "Four orientation paths. Pick the one that matches your company's stage and obligations.",
    columnPlan: "Plan",
    columnBestFor: "Best for",
    columnKeyValue: "Key value added",
    row1BestFor: "Investors & Holding Companies",
    row1Value: "A clean, legally compliant Mexican entity with all government registrations finalized.",
    row2BestFor: "Active Entrepreneurs",
    row2Value: "Total operational readiness. You get the keys to your business, including tax IDs and a functional bank account.",
    row3BestFor: "Established Brands",
    row3Value: "Total peace of mind. We protect your IP and handle the mandatory annual legal maintenance so you stay in good standing.",
    row4Plan: "Special Projects",
    row4BestFor: "Strategic Transactions",
    row4Value: "Specialized legal expertise for complex assets like coastal real estate, restricted-zone property, communal land, ejido matters, or tailored ownership structures.",
    howToChoose: "How to choose",
    choose1: "If you only need a Mexican company formed properly, choose Incorporate.",
    choose2: "If you need the company ready to operate, invoice, sign documents, and open a bank account, choose Full Launch.",
    choose3: "If your company needs ongoing legal maintenance, corporate records, IP protection, and foreign investor filings, choose Corporate Compliance.",
    choose4: "If your project involves restricted-zone property, coastal real estate, ejido land, or a tailored ownership structure, choose Special Projects.",
    stillUnsure: "Still unsure?",
    stillUnsureDesc: "Tell us what you are setting up in Mexico. We will identify the right route, confirm the required steps, and guide you through the process."
  },
  howItWorksPage: {
    importantToKnow: "Important to know",
    importantToKnowDesc: "Timelines depend on timely document delivery, project complexity, and applicable authority or notarial requirements.",
    readyToGetStarted: "Ready to get started?",
    step1: "Start your incorporation request",
    step1Desc: "Share the key details of your Mexico setup, and select a package if you already know which one fits.",
    step2: "Book a 20-minute validation call",
    step2Desc: "We review your request and confirm the right route, scope, and service fit before payment.",
    step3: "Payment and onboarding",
    step3Desc: "Once aligned, we send the payment link and begin your onboarding.",
    step4: "We handle the process",
    step4Desc: "We take care of incorporation and, if selected, RFC, bank account support, and governance setup.",
    step5: "Delivery",
    step5Desc: "You receive your company documents and related deliverables."
  },
  homePage: {
    step1: "Start your incorporation request",
    step1Desc: "Share the key details of your Mexico setup, and select a package if you already know which one fits.",
    step2: "Book a consultation",
    step2Desc: "We review your request on a 20-minute validation call and confirm the right route, scope, and service fit before any payment.",
    step3: "We handle incorporation & delivery",
    step3Desc: "Once aligned, we manage the entire process online and deliver your company documents and related deliverables."
  },
  faqPage: {
    stillHaveQuestions: "Still have questions?",
    stillHaveQuestionsDesc: "Book a 20-minute call with our team to discuss your specific project.",
    q1: "What does turnkey mean?",
    a1: "After the initial onboarding and document submission stage, BIMCORP MX handles the incorporation process and related setup steps online, without you managing notarial or authority filings personally.",
    q2: "Do I need to travel to Mexico?",
    a2: "Generally no, depending on the specific structure and requirements. Most of the process is handled online.",
    q3: "Do I pay before speaking with your team?",
    a3: "No. The first step is to submit your incorporation request, then a 20-minute call, and only after route validation do we send the payment link.",
    q4: "Can you help with foreign participation?",
    a4: "Yes. Foreign investment registration (RNIE) is included from the Incorporate plan, and ongoing RNIE updates are managed under Corporate Compliance.",
    q5: "Can you help with restricted-zone property or land-related projects?",
    a5: "Yes. Projects involving land, real estate, or restricted-zone property may require a tailored structuring route. We'll review the specifics on your validation call and confirm the right setup.",
    q6: "Do you provide accounting?",
    a6: "No, accounting services are not included in our offerings. We focus on incorporation, legal structure, and corporate governance.",
    q7: "Can you help with ongoing corporate governance?",
    a7: "Yes. That is part of Corporate Compliance, which covers statutory books, share certificate issuance, annual shareholder meeting management, copyright registration, and RNIE updates.",
    q8: "How long does the process usually take?",
    a8: "Timelines depend on timely document delivery, project complexity, and applicable authority or notarial requirements. We'll provide a specific timeline during your validation call.",
    q9: "What documents will I need?",
    a9: "Exact requirements depend on the project, but the onboarding step will clarify what is needed. Generally, you'll need identification documents, proof of address, and information about owners and directors.",
    q10: "Do I need a director or representative based in Mexico?",
    a10: "You do not need a resident director for governance purposes. However, you must designate a Legal Representative with a valid Mexican Tax ID (RFC) to manage interactions with the SAT and other authorities. BIMCORP can act as your Legal Representative in Mexico, handling all required interactions with local authorities on your behalf.",
    q11: "Can foreign companies own 100% of a Mexican entity?",
    a11: "Yes, in most sectors. The company's bylaws must include a \"Calvo Clause\" under which foreign shareholders agree to be treated as nationals with respect to their investment and waive the right to seek diplomatic protection over it.",
    q12: "How much does it cost to register an entity?",
    a12: "Pricing varies depending on the structure and scope of services. {servicesLink}",
    a12LinkLabel: "See our pricing",
    q13: "Can BIMCORP handle the full process on my behalf?",
    a13: "Yes. BIMCORP manages the end-to-end incorporation process in Mexico, from initial registration through ongoing corporate governance entirely online. Our team handles documentation, filings, and coordination with local authorities on your behalf.",
    q14: "Does BIMCORP offer ongoing compliance support?",
    a14: "Yes. Our Run the Corp package covers ongoing corporate governance, keeping your entity compliant and current on all required filings and obligations."
  },
  footer: {
    description: "A tailored, end-to-end digital service designed for seamless market entry and total compliance.",
    quickLinks: "Quick Links",
    contact: "Contact",
    privacy: "Privacy Notice",
    terms: "Terms and Conditions",
    allRights: "All rights reserved.",
    disclaimer: "Service scope, timing, and requirements may vary depending on the project, documentation, and applicable authority or notarial requirements."
  },
  wizard: {
    heroTitle: "Start Incorporation",
    heroSubtitle: "Tell us what you want to set up in Mexico. We set up your legal structure and manage the entire process online.",
    stepOf: "Step {{current}} of {{total}}",
    complete: "% complete",
    back: "Back",
    continue: "Continue",
    viewRecommendation: "View recommendation",
    common: {
      yes: "Yes",
      no: "No",
      notSure: "Not sure",
      required: "This question is required.",
      requiredText: "Please complete this field.",
      invalidEmail: "Please enter a valid email address.",
      selectCountryCode: "Please select a country code.",
      enterPhone: "Please enter a phone number.",
      uploadPartnerIDs: "Please upload the Official ID / Passport of each individual partner.",
      uploadLegalRepID: "Please upload the Official ID / Passport of the legal representative.",
      countryCode: "Country code",
      almostReady: "Your incorporation request is almost ready.",
      almostReadyDesc: "Please complete the required information below before submitting your form."
    },
    uploadCommon: {
      chooseFiles: "Choose files",
      chooseFile: "Choose file"
    },
    step0: {
      title: "Choose your package",
      knowsQuestion: "Do you already know which package you want?",
      selectPackage: "Select your package"
    },
    simplified: {
      step2: {
        title: "Project details",
        subtitle: "Tell us about your project so we can confirm the best route.",
        whatBuilding: "What business are you setting up in Mexico?",
        whatBuildingPlaceholder: "Brief description of your business...",
        hasAddress: "Do you have a Mexican address, with proof of address, that may be used for the company?",
        hasAddressNo: "No, I need one",
        rfcNeeded: "Will the company need support obtaining its Mexican Tax ID (RFC)?",
        bankAccountNeeded: "Will you need support opening a bank account?",
        governanceNeeded: "Do you want ongoing corporate governance support?",
        foreignParticipation: "Will the project involve foreign participation?",
        landRestrictedZone: "Will the project involve land, real estate, or restricted-zone property in Mexico?",
        taxIDs: "Tax ID(s), if already available",
        taxIDsHelp: "Provide the tax ID(s) of the partners. Add one per line.",
        taxIDsPlaceholder: "Tax IDs, one per line..."
      }
    },
    uploadPage: {
      title: "Upload documents",
      subtitle: "No documents are required at this stage, but you may upload them now to help speed up your validation call.",
      emailLabel: "Email used in your BIMCORP submission",
      emailPlaceholder: "you@example.com",
      emailHelp: "We use this email to attach your documents to the submission you already sent.",
      partnerIDsLabel: "Official ID / Passport of each individual partner",
      partnerIDsHelp: "Upload one file per partner.",
      legalRepIDLabel: "Official ID / Passport of the legal representative",
      taxIDsLabel: "Tax ID(s)",
      taxIDsHelp: "Provide the tax ID(s) of the partners and, if already known, the proposed legal representative. If there are multiple, add one per line.",
      taxIDsPlaceholder: "Tax IDs, one per line...",
      optionalTitle: "Optional documents, helpful to upload now",
      proofOfAddressLabel: "Proof of address (Mexican or foreign, as applicable)",
      immigrationDocsLabel: "Immigration / residency / entry permit document, if applicable",
      immigrationDocsHelp: "Upload residency card, immigration permit, entry document, or any equivalent immigration or stay document.",
      csfLabel: "For the legal representative, if Mexican: Constancia de Situación Fiscal",
      marriageCertLabel: "If married: marriage certificate",
      submitBtn: "Upload documents",
      submitting: "Uploading…",
      successTitle: "Documents uploaded",
      successMessage: "Your documents have been added to your BIMCORP file. Our team will review them ahead of your call.",
      errorNotFound: "We could not find a BIMCORP submission associated with this email. Please contact BIMCORP before uploading documents.",
      errorNoFiles: "Please attach at least one document.",
      errorGeneric: "We could not upload your documents. Please try again or contact BIMCORP.",
      uploadAnother: "Upload more documents"
    },
    packageNames: {
      incorporate: "Incorporate",
      fullLaunch: "Full Launch",
      corporateCompliance: "Corporate Compliance",
      specialProject: "Special Project Structuring"
    },
    packageDescs: {
      incorporate: "A one-time incorporation service for clients ready to form their company in Mexico.",
      fullLaunch: "Incorporation plus operational readiness: RFC, e.firma, and corporate bank account setup.",
      corporateCompliance: "Full Launch setup plus ongoing managed corporate compliance.",
      specialProject: "Tailored structuring for restricted-zone property, complex ownership, or special projects."
    },
    step1: {
      title: "Project details",
      whatBuilding: "What business are you setting up in Mexico?",
      whatBuildingPlaceholder: "Brief description of your business...",
      companyActivity: "What will the company do?",
      companyActivityPlaceholder: "Select activity...",
      activity: {
        technology: "Technology / Software",
        realEstate: "Real Estate",
        consulting: "Consulting / Services",
        manufacturing: "Manufacturing",
        retail: "Retail / E-commerce",
        hospitality: "Hospitality / Tourism",
        investment: "Investment / Holding",
        other: "Other"
      },
      activityOther: "Please specify the activity",
      activityOtherPlaceholder: "e.g., Healthcare, Education, Agriculture...",
      businessType: "Is this a new company or an expansion of an existing business?",
      businessTypeNew: "New company",
      businessTypeExpansion: "Expansion into Mexico",
      businessTypeSpv: "Special-purpose vehicle",
      hasNames: "Do you already have proposed company names?",
      nameOption1: "Option 1",
      nameOption2: "Option 2 (optional)",
      nameOption3: "Option 3 (optional)"
    },
    step2: {
      title: "Ownership structure",
      whoOwns: "Who will own the company?",
      individuals: "Number of individual partners",
      entities: "Number of entity / company partners",
      ownershipAgreed: "Have the ownership percentages already been agreed?",
      ownershipNeedHelp: "No, we need help",
      legalRep: "Who will act as the company's legal representative in Mexico?",
      legalRepPartner: "One of the partners",
      legalRepThirdParty: "A third party",
      legalRepNotDecided: "Not decided yet",
      legalRepName: "Name of the proposed legal representative",
      legalRepNamePlaceholder: "Full name"
    },
    step3: {
      title: "Setup needs",
      hasAddress: "Do you have a Mexican address (with proof of address) that may be used for the company?",
      hasAddressNeedOne: "No, I need one",
      rfc: "Will the company need support obtaining its Mexican Tax ID (RFC)?",
      bank: "Will you need support opening a bank account?",
      governance: "Do you want ongoing corporate governance support?"
    },
    step4: {
      title: "Special structuring + Documents",
      foreign: "Will the project involve foreign participation?",
      land: "Will the project involve land, real estate, or restricted-zone property in Mexico?",
      uploadTitle: "Upload documents",
      uploadIntro: "No documents are required at this stage, but you may upload them now to help speed up your validation call.",
      partnerIDsLabel: "Official ID / Passport of each individual partner",
      partnerIDsHelp: "Upload one file per partner.",
      chooseFiles: "Choose files",
      chooseFile: "Choose file",
      upload: "Upload",
      legalRepIDLabel: "Official ID / Passport of the legal representative",
      required: "Required",
      taxIDsLabel: "Tax ID(s)",
      taxIDsHelp: "Provide the tax ID(s) of the partners and, if already known, the proposed legal representative. If there are multiple, add one per line.",
      taxIDsPlaceholder: "Tax IDs (one per line)...",
      optionalTitle: "Optional documents (helpful to upload now)",
      proofAddress: "Proof of address (Mexican or foreign, as applicable)",
      immigration: "Immigration / residency / entry permit document, if applicable",
      immigrationHelp: "Upload residency card, immigration permit, entry document, or any equivalent immigration or stay document",
      csf: "For the legal representative, if Mexican: Constancia de Situación Fiscal",
      marriage: "If married: marriage certificate"
    },
    step5: {
      title: "Contact and scheduling",
      intro: "Complete your information to receive your recommended route and book your validation call.",
      fullName: "Full name *",
      fullNamePlaceholder: "Your full name",
      email: "Email *",
      emailPlaceholder: "your.email@example.com",
      phone: "Phone / WhatsApp *",
      phonePlaceholder: "+1 234 567 8900",
      country: "Country *",
      countryPlaceholder: "Your country",
      preferredLang: "Preferred language",
      langEnglish: "English",
      langSpanish: "Spanish",
      langOther: "Other"
    },
    recommendation: {
      title: "Recommended route",
      pricingTitle: "Pricing",
      ready: "Ready to move forward?",
      readyDesc: "Book your 20-minute validation call below. No payment is required before the call.",
      bookCall: "Book your 20-minute validation call",
      backToWizard: "Back to request",
      installmentsAvailable: "(Installments available)",
      oneTimeFee: "one-time fee",
      initialSetupFee: "initial setup fee",
      monthSuffix: "/month",
      commitment: "12-month minimum commitment",
      startCorpTitle: "Incorporate",
      startCorpDesc: "A one-time incorporation service for clients ready to form their company in Mexico.",
      launchCorpTitle: "Full Launch",
      launchCorpDesc: "A one-time setup for clients who want incorporation, Tax ID (RFC), e.firma, and corporate bank account setup.",
      runCorpTitle: "Corporate Compliance",
      runCorpDesc: "Full Launch setup plus managed compliance for clients who want continuity after incorporation.",
      customProjectTitle: "Custom project",
      customProjectDesc: "Your project may require a tailored legal and ownership route. We'll review the specifics on your validation call and confirm the right setup and quote before any payment.",
      customPricingNote: "This route requires a custom quote. We'll review the specifics and confirm scope and pricing on your 20-minute validation call. No payment is required before the call.",
      scheduleTitle: "Schedule your validation call",
      scheduleDesc: "Your incorporation request has been received. Please schedule your validation call so our team can review your request and confirm the next steps.",
      loadingScheduler: "Loading scheduler…",
      allSetTitle: "You're all set.",
      allSetBody: "We received your information and your scheduled validation call. Our team will review your request before the meeting.",
      // Compact post-submission summary
      requestSubmittedTitle: "Your request has been submitted.",
      packageSummaryPrefix: "Based on your selection, the package for you is",
      packageSummarySuffix: "BIMCORP will confirm the final scope during your validation call.",
      packageSummaryCustom: "Based on your selection, your route will be confirmed during your validation call. BIMCORP will share scope and pricing before any payment.",
      returnHome: "Return home",
      callScheduledLabel: "Validation call scheduled",
      scheduleReminder: "Your request has been submitted. Please schedule your validation call to complete the process.",
      restart: "Start new request",
      selectedNote: "Based on your selection, this is the package you chose. BIMCORP will confirm the final scope during your validation call.",
      conflictNote: "Some of your answers may require additional review. BIMCORP will confirm whether this package is appropriate during your validation call."
    },
    overlay: {
      titleUpload: "Please wait while we upload your documents.",
      titleSubmit: "Please wait while we submit your request.",
      subtitle: "Do not close this window."
    },
    readonly: {
      banner: "Your request has already been submitted. Don't worry, if you need to make any changes or clarify anything, please let us know during your validation call.",
      viewRecommendation: "View my recommendation"
    }
  },
  insights: {
    eyebrow: "Insights",
    title: "Notes on incorporating in Mexico",
    subtitle: "Practical writing on company formation, foreign investment registration, corporate compliance, and the legal structures behind doing business in Mexico.",
    readMore: "Read more",
    by: "By",
    backToInsights: "Back to Insights",
    empty: "No articles yet. Check back soon.",
    metaTitle: "Insights",
    metaDescription: "BIMCORP MX Insights: practical notes on incorporating in Mexico, foreign investment registration, corporate compliance, and legal structures."
  }
};

export default en;
